import { prefixUrlWithHttp } from 'conversations/utils/urlUtils'
import { EndUser } from 'shared/typings/endUser/EndUser'
import { UserLite } from 'shared/typings/user/UserLite'
import { UserIdType } from 'shared/typings/users/UserIdType'

const DEFAULT_DISPLAY_NAME = 'Site visitor'

export const getShortDisplayName = (customer?: UserLite): string => {
  if (!customer) {
    return DEFAULT_DISPLAY_NAME
  }

  let name = customer.name
  if (name) {
    name = name.split(' ')[0]
  }

  const displayName = name || customer.email
  if (displayName) {
    return displayName
  }

  return DEFAULT_DISPLAY_NAME
}

export const isEndUser = (userType: UserIdType): boolean =>
  [UserIdType.END_USER, UserIdType.LEAD].includes(userType)

export const getRole = (endUser?: EndUser): string | undefined =>
  endUser?.socialProfile?.employment?.title

export const getCompanyName = (endUser?: EndUser): string | undefined =>
  endUser?.endUserEnrichment?.company?.data?.name

export const getCompanyUrl = (endUser?: EndUser): string | undefined =>
  prefixUrlWithHttp(endUser?.endUserEnrichment?.company?.data?.url)
